export default __webpack_public_path__ + "static/media/es.21675a09.svg";